import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/app/[locale]/analytics/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsFeed"] */ "/home/runner/work/brics-website/brics-website/sections/analytics-feed/analytics-feed.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/hooks.tsx");
